<div class="text-center">
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
    <circle cx="50%" cy="50%" r="35%" [attr.fill]="'url(#'+ this.category +'-' + this.name + ')'" stroke-width="4%" />
  </svg>
  <p>
    <ng-content></ng-content>
  </p>
</div>
